import Header from "@/components/laka/Header";
import Hero from "@/components/laka/Hero";
import Positioning from "@/components/laka/Positioning";
import Treatments from "@/components/laka/Treatments";
import Featured from "@/components/laka/Featured";
import LaserBlock from "@/components/laka/LaserBlock";
import Pricing from "@/components/laka/Pricing";
import Memberships from "@/components/laka/Memberships";
import Method from "@/components/laka/Method";
import Centro from "@/components/laka/Centro";
import Testimonials from "@/components/laka/Testimonials";
import Contact from "@/components/laka/Contact";
import FinalCTA from "@/components/laka/FinalCTA";
import Footer from "@/components/laka/Footer";
import WhatsAppFloat from "@/components/laka/WhatsAppFloat";

const Home = () => (
  <div data-testid="laka-home" className="min-h-screen bg-[#FBF6F2]">
    <Header />
    <main>
      <Hero />
      <Positioning />
      <Treatments />
      <Featured />
      <LaserBlock />
      <Pricing />
      <Memberships />
      <Method />
      <Centro />
      <Testimonials />
      <Contact />
      <FinalCTA />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default Home;
